import { useParams } from "react-router-dom";
import { ResultReportScreen } from "@/pages/VivaMelhorPage";

/**
 * Shareable public report route (/relatorio-metabolico/:token) — no login.
 * Reuses the exact same `ResultReportScreen` rendered at the end of the
 * /viva-melhor flow, so admins can share this link with the lead via
 * WhatsApp and the lead sees the report they would have seen right after
 * submitting the test.
 */
export default function PublicMetabolicReportPage() {
  const { token } = useParams();
  return <ResultReportScreen token={token} patientName="" />;
}
